var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Compare","icon":"down-left-and-up-right-to-center","css-class":"analytics-compare","default-label":"Compare","show-divisions-dropdown":false,"can-download":_setup.canDownload,"get-sheet-config":_setup.getSheetConfig}},[_c(_setup.DivisionsMetrics,{ref:"metricsRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }